// React and related imports
import { useState, useEffect } from 'react';

// React Router related imports
import { useSearchParams } from 'react-router-dom';

export const usePagination = (defaultSize = 10, defaultPage = 1) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const currentPageParam = parseInt(
    searchParams.get('page') || defaultPage.toString(),
    10
  );

  const sizeParam = parseInt(
    searchParams.get('size') || defaultSize.toString(),
    10
  );

  const [currentPage, setCurrentPage] = useState<number>(currentPageParam);
  const [size, setSize] = useState<number>(sizeParam);

  useEffect(() => {
    if (currentPage !== currentPageParam || size !== sizeParam) {
      setCurrentPage(currentPageParam);
      setSize(sizeParam);
    }
  }, [currentPageParam, sizeParam]);

  useEffect(() => {
    setSearchParams((prev) => {
      prev.set('page', currentPage.toString());
      prev.set('size', size.toString());
      return prev;
    });
  }, [currentPage, size, setSearchParams]);

  return { currentPage, setCurrentPage, size, setSize };
};
